import * as signalR from "@microsoft/signalr";

class ChatHubService {

    private connection: signalR.HubConnection | null = null;

    async start(token: string) {

        if (this.connection) {

            if (
                this.connection.state === signalR.HubConnectionState.Connected
            ) {
                return;
            }

            if (
                this.connection.state === signalR.HubConnectionState.Connecting ||
                this.connection.state === signalR.HubConnectionState.Reconnecting
            ) {
                return;
            }
        }
//https://localhost:7166
//https://api-real.priceworth.com:7443
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl("https://api-real.priceworth.com:7443/chatHub", {
                accessTokenFactory: () => token
            })
            .withAutomaticReconnect()
            .build();

        await this.connection.start();

        console.log("SignalR Connected");
    }

    async stop() {

        if (!this.connection)
            return;

        if (
            this.connection.state !== signalR.HubConnectionState.Disconnected
        ) {
            await this.connection.stop();
        }

        this.connection = null;
    }

    isConnected() {

        return (
            this.connection?.state === signalR.HubConnectionState.Connected
        );
    }

    async joinGroup(groupId: string) {

        if (!this.isConnected()) {
            console.log("SignalR not connected");
            return;
        }

        await this.connection!.invoke("JoinGroup", groupId);
    }

    async leaveGroup(groupId: string) {

        if (!this.isConnected())
            return;

        await this.connection!.invoke("LeaveGroup", groupId);
    }

    async sendMessage(data: any) {

        if (!this.isConnected()) {
            alert("SignalR not connected");
            return;
        }

        await this.connection!.invoke("SendMessage", data);
    }

    async editMessage(messageId: string, message: string) {

        if (!this.isConnected())
            return;

        await this.connection!.invoke(
            "EditMessage",
            messageId,
            message
        );
    }

    async deleteMessage(messageId: string) {

        if (!this.isConnected())
            return;

        await this.connection!.invoke(
            "DeleteMessage",
            messageId
        );
    }

    async typing(groupId: string, userName: string) {

        if (!this.isConnected())
            return;

        await this.connection!.invoke(
            "Typing",
            groupId,
            userName
        );
    }

    async stopTyping(groupId: string, userName: string) {

        if (!this.isConnected())
            return;

        await this.connection!.invoke(
            "StopTyping",
            groupId,
            userName
        );
    }

    async addReaction(chatMessageId: string, reaction: string) {

        if (!this.isConnected())
            return;

        await this.connection!.invoke("AddReaction", {
            chatMessageId,
            reaction
        });
    }

   onReceiveMessage(callback: any) {
    if (!this.connection) return;

    this.connection.off("ReceiveMessage");
    this.connection.on("ReceiveMessage", callback);
}

   onMessageEdited(callback: any) {
    if (!this.connection) return;

    this.connection.off("MessageEdited");
    this.connection.on("MessageEdited", callback);
}

onMessageDeleted(callback: any) {
    if (!this.connection) return;

    this.connection.off("MessageDeleted");
    this.connection.on("MessageDeleted", callback);
}

onUserTyping(callback: any) {
    if (!this.connection) return;

    this.connection.off("UserTyping");
    this.connection.on("UserTyping", callback);
}

onUserStopTyping(callback: any) {
    if (!this.connection) return;

    this.connection.off("UserStopTyping");
    this.connection.on("UserStopTyping", callback);
}

onReactionUpdated(callback: any) {
    if (!this.connection) return;

    this.connection.off("ReactionUpdated");
    this.connection.on("ReactionUpdated", callback);
}
}
// eslint-disable-next-line 
export default new ChatHubService();